import cropApplicationDraftReducer from "./cropApplicationDraftReducer";
import processingApplicationDraftReducer from "./processingApplicationDraftReducer";

const applicationDraftReducer = {
    cropApplicationDraft: cropApplicationDraftReducer,
    processingApplicationDraft: processingApplicationDraftReducer
}

export default applicationDraftReducer;